import { helper } from '@ember/component/helper';

import config from 'rise-ui/config/config.js';

export default helper(function imageDownloadSizesHelper() {
  return config.timeSeries?.imageDownloadSizes ?? [];
});
